import React, { Component } from "react";
import { withStyles } from "material-ui/styles";

const styles = theme => ({
  container: {
    flex: "1 1 auto",
    minWidth: 0,
    minHeight: 0,
    boxSizing: "border-box",
    backgroundColor: theme.palette.background.default,
    overflow: "auto"
  },

  containerFullWidth: {
    width: "100%"
  }
});

class MainContainer extends Component {
  render() {
    const {
      classes,
      children,
      shouldRenderMobileMenu
    } = this.props;

    const mainClass = shouldRenderMobileMenu
      ? `${classes.container} ${classes.containerFullWidth}`
      : classes.container;

    return (
      <main className={mainClass}>
        {children}
      </main>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MainContainer);
